'use client';

import {Box, styled} from '@mui/material';

export const StyledModalBackdrop = styled(Box)(({theme}) => ({
  position: 'fixed',
  inset: 0,
  zIndex: 1300,
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  padding: theme.spacing(4, 2),
  overflowY: 'auto',
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  animation: 'backdropFadeIn 200ms ease-out',
  '@keyframes backdropFadeIn': {
    from: {opacity: 0},
    to: {opacity: 1},
  },
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2, 1),
    alignItems: 'stretch',
  },
}));

export const StyledModalPanel = styled(Box)(({theme}) => ({
  position: 'relative',
  width: '100%',
  maxWidth: 1100,
  margin: 'auto',
  backgroundColor: theme.palette.background.white,
  borderRadius: theme.shape.borderRadiusLg,
  paddingTop: theme.spacing(5),
  paddingBottom: theme.spacing(2),
  boxShadow: '0 12px 40px rgba(0, 0, 0, 0.5)',
  // Below the lg breakpoint the form keeps its stacked/full-width layout, so the
  // centered heading runs up into the top-right corner. Give it extra headroom
  // to clear the absolutely-positioned close button (top 16px + 36px tall ≈ 52px).
  [theme.breakpoints.down('lg')]: {
    paddingTop: theme.spacing(7),
  },
  animation: 'panelReveal 300ms ease-out',
  '@keyframes panelReveal': {
    from: {
      opacity: 0,
      transform: 'translateY(16px) scale(0.98)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0) scale(1)',
    },
  },
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
  },
}));

export const StyledModalSections = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const StyledModalCloseButton = styled('button')(({theme}) => ({
  // reset native button defaults
  appearance: 'none',
  padding: 0,
  font: 'inherit',
  border: 'none',

  position: 'absolute',
  top: theme.spacing(2),
  right: theme.spacing(2),
  width: 36,
  height: 36,
  borderRadius: '50%',
  backgroundColor: 'transparent',
  color: theme.palette.text.dark,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  zIndex: 1,
  transition: 'background-color 150ms ease',
  '&:hover': {
    backgroundColor: theme.palette.grey[100],
  },
  '&:active': {
    backgroundColor: theme.palette.grey[200],
  },
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: 2,
  },
}));
